import React from 'react';
import Files from '@/containers/Files';
import Assets from '@/containers/Asset';
import Licenses from '@/containers/License';
import Missions from '@/containers/Mission';
import Providers from '@/containers/Provider';
import { Route, Switch } from 'react-router-dom';
import Instruments from '@/containers/Instrument';
import Collections from '@/containers/Collection';
import Calibrations from '@/containers/Calibration';
import CreateMosaicAsset from '@/containers/Asset/components/CreateMosaicAsset';
import NewMissionProvider from '@/containers/Mission/components/NewMissionProvider';
import CreateTilesetAssets from '@/containers/Asset/components/CreateTilesetAssets';
import NewMissionInstrument from '@/containers/Mission/components/NewMissionInstrument';
import CreateWebServiceAsset from '@/containers/Asset/components/CreateWebServiceAsset';
import CreateAssetRequestList from '@/containers/Asset/components/CreateAssetRequestList';
import CreateStreetviewAssets from '@/containers/Asset/components/CreateStreetviewAssets';
import CreateObliqueTilesetAssets from '@/containers/Asset/components/CreateObliqueTilesetAssets';

export default () => (
  <Switch>
    <Route path="/assets/files" component={Files} />
    <Route path="/assets/assets" component={Assets} />
    <Route path="/assets/missions/providers" component={NewMissionProvider} />
    <Route path="/assets/missions/instruments" component={NewMissionInstrument} />
    <Route path="/assets/missions" component={Missions} />
    <Route path="/assets/collections" component={Collections} />
    <Route path="/assets/providers" component={Providers} />
    <Route path="/assets/licenses" component={Licenses} />
    <Route path="/assets/intruments" component={Instruments} />
    <Route path="/assets/calibrations" component={Calibrations} />
    <Route path="/assets/create/requests" component={CreateAssetRequestList} />
    <Route path="/assets/create/web_service" component={CreateWebServiceAsset} />
    <Route path="/assets/create/mosaic" component={CreateMosaicAsset} />
    <Route path="/assets/create/tileset" component={CreateTilesetAssets} />
    <Route path="/assets/create/oblique" component={CreateObliqueTilesetAssets} />
    <Route path="/assets/create/streetview" component={CreateStreetviewAssets} />
  </Switch>
);
